<select [(ngModel)]="SelectedOption" (change)="updateSelected()" class="text-box max-w-xl" [disabled]="currentQuestion.NASelected">
  <option disabled  hidden [ngValue]="null" class="text-grey-900">Please select...</option>
  @for (a of currentQuestion.QuestionAnswers; track a) {
    <option [ngValue]="a" [disabled]="a.ID == -1">
      {{a.Description}}
    </option>
  }
</select>
@if (currentQuestion.AllowNA) {
  <div class="mt-4 mx-2 flex items-center">
    <app-simple-toggle class="mr-2" [(isChecked)]="currentQuestion.NASelected" (isCheckedChange)="validateAnswer()"></app-simple-toggle>
    <label (click)="updateNA()" class="hover:cursor-pointer">Not Applicable</label>
  </div>
}